/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from "react";
import { NumericFormat, NumberFormatValues } from "react-number-format";
import { OutlinedInput, InputAdornment, makeStyles, createStyles } from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";
import { Colors } from "../../styles";
/**
 * for docs see https://www.npmjs.com/package/react-number-format#props
 * all TextField props are acceped too
 */
type Props = TextFieldProps & {
    thousandSeparator?: boolean | string;
    decimalSeparator?: boolean | string;
    thousandsGroupStyle?: "thousand" | "lakh" | "wan";
    decimalScale?: number;
    fixedDecimalScale?: boolean;
    displayType?: "input" | "text";
    prefix?: string;
    suffix?: string;
    format?: string;
    removeFormatting?: (formattedValue: string) => string;
    mask?: string | string[];
    value?: number | string;
    defaultValue?: number | string;
    isNumericString?: boolean;
    customInput?: React.ComponentType<any>;
    allowNegative?: boolean;
    allowEmptyFormatting?: boolean;
    onValueChange?: (values: NumberFormatValues) => void;
    type?: "text" | "tel" | "password";
    isAllowed?: (values: NumberFormatValues) => boolean;
    renderText?: (formattedValue: string) => React.ReactNode;
    //getInputRef?: ((el: HTMLInputElement) => void) | React.Ref<any>;
    allowedDecimalSeparators?: Array<string>;
    adornment?: string;
    [key: string]: any;
    error?: boolean;
};

const useStyles = makeStyles(() =>
    createStyles({
        adornment: {
            marginRight: 30,
        },
    }),
);

const useOutlinedInputStyles = (
    error: boolean,
    disabled: boolean,
): (() => Record<string, string>) =>
    makeStyles(() => ({
        root: {
            marginTop: 7,
            borderRadius: 28,
            height: 56,
            background: disabled ? Colors.anthracite5 : Colors.white,

            fontSize: 22,
            fontWeight: 300,
            fontStretch: "normal",
            fontStyle: "normal",
            fontFamily: "innogyWEB",
            lineHeight: 1.27,
            letterSpacing: "normal",
            color: Colors.anthracite,

            "& $notchedOutline": {
                borderColor: error ? Colors.radiantRed : Colors.anthracite25,
                borderWidth: "1px",
            },
            "&:hover $notchedOutline": {
                borderColor: error ? Colors.radiantRed : Colors.mellowYellow,
                borderWidth: "1px",
            },
            "&$focused $notchedOutline": {
                borderColor: error ? Colors.radiantRed : Colors.blueBright,
                borderWidth: "1px",
            },
            "&$focused": {
                //backgroundColor: Colors.eggshell,
            },
        },
        focused: {},
        notchedOutline: {},

        input: {
            padding: 20,
            textAlign: "right",
        },
    }));

export const NumberInput: FC<Props> = (props: Props) => {
    const { error, disabled, style } = props;
    const classes = useStyles();
    const outlinedInputClasses = useOutlinedInputStyles(error || false, disabled || false)();
    return (
        <OutlinedInput
            classes={outlinedInputClasses}
            className={props.className}
            labelWidth={0}
            inputComponent={NumericFormat as any}
            inputProps={
                {
                    style: {
                        textAlign: "end",
                        fontSize: 22,
                    },
                    ...props,
                } as any
            }
            endAdornment={
                props.adornment ? (
                    <InputAdornment position="end" className={classes.adornment}>
                        {props.adornment}
                    </InputAdornment>
                ) : undefined
            }
            style={style}
        />
    );
};
